
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 46 42"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M14.077 14.879l6.99-6.991v20.97a2.045 2.045 0 004.091 0V8.395l6.463 7.178a2.047 2.047 0 103.041-2.737L25.082 2.19l-.019-.016-1.926-2.14L20.24 2.93l-9.056 9.055a2.047 2.047 0 002.893 2.893"}}),_c('path',{attrs:{"d":"M43.454 25.602a2.045 2.045 0 00-2.045 2.046v10.226H4.591V27.647a2.045 2.045 0 00-4.09 0V39.92c0 1.13.915 2.045 2.044 2.045h40.91c1.13 0 2.045-.916 2.045-2.046V27.648c0-1.13-.916-2.046-2.046-2.046"}})])])
          )
        }
      }
    